// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3xnvA","header":"Messages_header__ZkleO"};